import { cn } from '@/lib/utils';

interface MobileSwitchProps {
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
    disabled?: boolean;
    className?: string;
}

export function MobileSwitch({
    checked,
    onCheckedChange,
    disabled = false,
    className
}: MobileSwitchProps) {
    return (
        <button
            role="switch"
            aria-checked={checked}
            disabled={disabled}
            onClick={() => onCheckedChange(!checked)}
            className={cn(
                'relative inline-flex h-7 w-12 flex-shrink-0 cursor-pointer items-center rounded-full transition-colors',
                checked ? 'bg-primary' : 'bg-muted',
                disabled && 'opacity-50 cursor-not-allowed',
                className
            )}
        >
            <span
                className={cn(
                    'pointer-events-none block h-5 w-5 rounded-full bg-white shadow-md transition-transform',
                    checked ? 'translate-x-6' : 'translate-x-1'
                )}
            />
        </button>
    );
}
